/*
  BDEK stockists (sections/bdek-stockists.liquid)
  One filter at a time: a state (map tile), a region (chip) or a search.
  - Search matches store name, city, state/country (state names count too, e.g. "Texas").
  - Groups with no matches are hidden; "Show all stores" clears the filter.
  - Phones: each state/country group starts closed; groups open when a filter is active.
*/
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.bdekStockistsReady) return;
    root.dataset.bdekStockistsReady = 'true';

    var input = root.querySelector('[data-bdek-stockists-search]');
    var count = root.querySelector('[data-bdek-stockists-count]');
    var clearBtn = root.querySelector('[data-bdek-stockists-clear]');
    var tools = root.querySelector('.bdek-stockists__tools');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-bdek-stockists-group]'));
    var tiles = root.querySelectorAll('[data-bdek-state-filter]');
    var chips = root.querySelectorAll('[data-bdek-region-filter]');
    var filter = { type: 'all', value: '' };

    function setPressed() {
      tiles.forEach(function (t) {
        t.setAttribute('aria-pressed', filter.type === 'state' && t.getAttribute('data-bdek-state-filter') === filter.value ? 'true' : 'false');
      });
      chips.forEach(function (c) {
        var v = c.getAttribute('data-bdek-region-filter');
        var on = (filter.type === 'region' && v === filter.value) || (filter.type === 'all' && v === 'all');
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function apply() {
      var q = filter.type === 'search' ? filter.value.trim().toLowerCase() : '';
      var shown = 0;
      var active = filter.type !== 'all' && !(filter.type === 'search' && !q);

      groups.forEach(function (group) {
        var inGroup = 0;
        var groupOk = true;
        if (filter.type === 'state') groupOk = group.getAttribute('data-state') === filter.value;
        if (filter.type === 'region') groupOk = group.getAttribute('data-region') === filter.value;
        var title = group.querySelector('summary span').textContent.toLowerCase();
        var titleHit = q && title.indexOf(q) !== -1;

        group.querySelectorAll('[data-bdek-stockist]').forEach(function (item) {
          var hit = groupOk && (!q || titleHit || item.getAttribute('data-search').indexOf(q) !== -1);
          item.hidden = !hit;
          if (hit) inGroup++;
        });
        group.hidden = inGroup === 0;
        shown += inGroup;
        // Phones: closed by default, open while filtering
        if (phone.matches) group.open = active && inGroup > 0;
      });

      if (count) {
        var text = shown === 0 ? count.getAttribute('data-none')
          : shown === 1 ? count.getAttribute('data-one')
          : (count.getAttribute('data-template') || '[count] stores').replace('[count]', shown);
        count.textContent = text;
      }
      if (clearBtn) clearBtn.hidden = !active;
      setPressed();
    }

    function scrollToTools() {
      if (!tools) return;
      tools.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var code = tile.getAttribute('data-bdek-state-filter');
        var same = filter.type === 'state' && filter.value === code;
        filter = same ? { type: 'all', value: '' } : { type: 'state', value: code };
        if (input) input.value = '';
        apply();
        if (!same) scrollToTools();
      });
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var v = chip.getAttribute('data-bdek-region-filter');
        filter = v === 'all' ? { type: 'all', value: '' } : { type: 'region', value: v };
        if (input) input.value = '';
        apply();
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        filter = input.value.trim() ? { type: 'search', value: input.value } : { type: 'all', value: '' };
        apply();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        filter = { type: 'all', value: '' };
        if (input) input.value = '';
        apply();
        if (input) input.focus();
      });
    }

    // Desktop shows every group open; only phones collapse them
    groups.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (!phone.matches && !g.open) g.open = true;
      });
    });

    phone.addEventListener('change', function () {
      if (!phone.matches) groups.forEach(function (g) { g.open = true; });
      apply();
    });

    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-stockists]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
